<template>
  <div class="modal" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h1>Edit Shift</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveShift">

          <div class="card text-white bg-secondary mb-3">
            <div class="card-body mb-0">
              <h2 v-if="shiftData.event">Event Details</h2>
              <dl v-if="shiftData.event" class="row">
                <dt class="col-sm-3">Name</dt>
                <dd class="col-sm-9">{{ shiftData.event.name }}</dd>
                <dt class="col-sm-3">Date</dt>
                <dd class="col-sm-9">{{ formatDate(shiftData.event.date) }}</dd>
              </dl>
            </div>
          </div>


          <!-- Name -->
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" v-model="shiftData.name" id="name" ref="inputName" required>
          </div>

          <!-- Location -->
          <div class="mb-3">
            <label for="location" class="form-label">Location</label>
            <div v-for="location in locations" :key="location.id" class="form-check">
              <input class="form-check-input" type="radio" :id="'location-' + location.id" :value="location.id"
                     v-model="shiftData.location" required>
              <label class="form-check-label" :for="'location-' + location.id">{{ location.name }} ({{
                  location.code
                }})</label>
            </div>
          </div>

          <!-- Capacity -->
          <div class="mb-3">
            <label for="capacity" class="form-label">Capacity</label>
            <input type="number" min="0" class="form-control" v-model="shiftData.capacity" id="capacity" required>
          </div>

          <!-- Start -->
          <div class="mb-3">
            <label for="start_datetime" class="form-label">Start</label>
            <input type="datetime-local" class="form-control" id="start_datetime" v-model="shiftData.start" required
                   placeholder="Shift start date and time"/>
          </div>

          <!-- End -->
          <div class="mb-3">
            <label for="end_datetime" class="form-label">End</label>
            <input type="datetime-local" class="form-control" id="end_datetime" v-model="shiftData.end" required
                   placeholder="Shift end date and time"/>
          </div>

          <!-- Shift length -->
          <div class="card text-white bg-secondary mb-3">
            <div class="card-body mb-0">
              <dl class="row">
                <dt class="col-sm-3">Shift length</dt>
                <dd class="col-sm-9">{{ shiftLength() }} hours</dd>
              </dl>
            </div>
          </div>

          <!-- Tag -->
          <div class="mb-3">
            <label for="tag" class="form-label">Tag</label>
            <select class="form-control" v-model="shiftData.tag" id="tag">
              <option v-for="tag in tags" :key="tag.value" :value="tag.value">{{ tag.label }}</option>
            </select>
          </div>

          <!-- Score -->
          <div class="mb-3">
            <label for="score" class="form-label">Score</label>
            <input type="number" class="form-control" v-model="shiftData.score" id="score" min="0" required>
          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel</button>
        <button type="button" class="btn btn-primary" @click="saveShift"
                :disabled="isSaveButtonDisabled">Save shift
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: 'EditShiftModal',
  props: {
    shift: {
      type: Object,
      required: true,
    },
    locations: {
      type: Array,
      required: true,
      default: () => [],
    },
    tags: {
      type: Array,
      required: true,
      default: () => [],
    },

  },
  emits: ['close', 'save-shift'], // Define the emits options
  mounted() {
    this.$refs.inputName.focus();
    this.initializeShiftData();
  },
  data() {
    return {
      shiftData: {},
    };
  },
  watch: {
    shift: {
      immediate: true,
      handler() {
        this.initializeShiftData();
      },
    },
  },
  computed: {
    sortedLocations() {
      return this.locations.slice().sort((a, b) => a.name.localeCompare(b.name));
    },
    isSaveButtonDisabled() {
      return !this.shiftData.name ||
          !this.shiftData.location ||
          !this.shiftData.capacity ||
          !this.shiftData.tag;
    },
  },
  methods: {
    initializeShiftData() {
      this.shiftData = {
        ...this.shift,
        location: this.shift.location.id,
        start: this.formatDateTimeToLocal(this.shift.start),
        end: this.formatDateTimeToLocal(this.shift.end),
      };
    },
    formatDate(date) {
      return dayjs(date).format('dddd DD/MM/YYYY');
    },
    formatDateTimeToLocal(dateTime) {
      return dayjs.utc(dateTime).local().format('YYYY-MM-DDTHH:mm');
    },
    formatDateTimeToUTC(dateTime) {
      return dayjs(dateTime).utc().format();
    },
    async saveShift() {
      this.shiftData.start = this.formatDateTimeToUTC(this.shiftData.start);
      this.shiftData.end = this.formatDateTimeToUTC(this.shiftData.end);
      this.$emit('save-shift', this.shiftData);
    },
    shiftLength() {
      if (this.shiftData.start && this.shiftData.end) {
        const start = dayjs(this.shiftData.start);
        const end = dayjs(this.shiftData.end);
        return dayjs.duration(end.diff(start)).asHours().toFixed(2);
      }
      return "/";
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>